module.exports = __webpack_public_path__ + "assets-cabinet/img/accounts-cards-icon-black.c9507ef0.svg";